import { Form, Input, Button, Card, Typography, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PASSWORD_MIN_LENGTH } from '@bom/shared';
import { useChangePassword } from '../../api/auth';
import { useSessionStore } from '../../stores/sessionStore';
import { ApiError } from '../../lib/apiClient';

export function ChangePasswordPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const mut = useChangePassword();
  const clearMustChange = useSessionStore((s) => s.clearMustChangePassword);
  const isPlatformAdmin = useSessionStore((s) => s.user?.is_platform_admin ?? false);

  const onFinish = (values: { current_password: string; new_password: string }) => {
    mut.mutate(values, {
      onSuccess: () => {
        message.success('密码已修改');
        clearMustChange(); // 清掉首登强制改密标记，避免守卫再次弹回
        navigate(isPlatformAdmin ? '/' : '/select-tenant', { replace: true });
      },
      onError: (err) => {
        if (err instanceof ApiError) {
          if (err.status === 401) message.error('当前密码不正确');
          else if (/differ/i.test(err.message)) message.error('新密码不能与当前密码相同');
          else message.error(err.message || '修改失败');
        } else message.error('修改失败');
      },
    });
  };

  return (
    <div
      style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f3f3f3' }}
    >
      <Card style={{ width: 420 }}>
        <Typography.Title level={4}>修改密码</Typography.Title>
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            name="current_password"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item
            name="new_password"
            label="新密码"
            dependencies={['current_password']}
            rules={[
              { required: true, message: '请输入新密码' },
              { min: PASSWORD_MIN_LENGTH, message: `密码至少 ${PASSWORD_MIN_LENGTH} 位` },
              ({ getFieldValue }) => ({
                validator(_, v) {
                  if (v && v === getFieldValue('current_password')) {
                    return Promise.reject(new Error('新密码不能与当前密码相同'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" block loading={mut.isPending}>
              确认修改
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
